import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AccountService } from 'src/app/shared/services/account/account.services';
import { LocalStorageService } from 'angular-web-storage';
import * as Sentry from "@sentry/angular";
import { LocalStorageKeys } from 'src/app/shared/utils/local.storage.keys';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../styles/card.style.component.scss']
})
export class LoginComponent implements OnInit {

    public loading: boolean = false;;
    public errorHint: boolean = false;
    public showPassword: boolean = false;
    public email: string = '';
    public password: string = '';
    public checked: boolean = false;
    public errorHintGeneric: boolean = false;;
    public code: string = '';
    public showCode: boolean = false;
    public errorApprovedHint: boolean = false;
    public redirectUrl: string = '';

    constructor(
        private readonly location: Location,
        private readonly router: Router,
        private readonly accountService: AccountService,
        private readonly localStorageService: LocalStorageService,
        private readonly activatedRoute: ActivatedRoute,
    ) { }

    public ngOnInit(): void {
        this.initLoginComponent();
    }

    public async initLoginComponent(): Promise<void> {
        this.loading = true;
        await this.verifyIfHasRedirectUrl();
        this.accountService.getRsaPublicKey().subscribe();
        this.accountService.verifyAuthentication().subscribe((authenticated) => {
            Sentry.setUser({ email: this.localStorageService.get(LocalStorageKeys.USER_EMAIL_ENTRY) });

            if (authenticated) {
                this.router.navigate(['/home']);
            } else {
                this.accountService.getRsaPublicKey().subscribe();
                this.email = this.localStorageService.get(LocalStorageKeys.USER_EMAIL_ENTRY);
            }

            this.checked = this.email ? true : false;
        }).add(() => this.loading = false);
    }

    public login(): void {
        this.errorHint = false;
        this.errorHintGeneric = false;
        this.errorApprovedHint = false;
        this.loading = true;
        Sentry.setUser({ email: this.email });
        this.accountService.loginUser(this.email, this.password, this.code).subscribe(async () => {
            if(this.checked) {
                this.localStorageService.set(LocalStorageKeys.USER_EMAIL_ENTRY, this.email);
            }
            this.router.navigate([this.redirectUrl || '/home']);
        }, error => {
            if(error?.error?.message?.includes('UserNotConfirmedException')) {
                this.showCode = true;
            } else if(error?.error?.message?.includes('This user has MFA enabled, and secret code has not been sent')){
                this.showCode = true;
            }  else if(error?.error?.message?.includes('incorrect')) {
                this.errorHint = true;
            }
            else if(error?.error?.message?.includes('User not approved yet')) {
                this.errorApprovedHint = true;
            }
            else {
                this.errorHintGeneric = true;
            }
        }).add(() => {
            this.loading = false;
        });
    }

    public cancel(): void {
        this.location.back();
    }

    public forgotPassword(): void {
        this.router.navigate(['account/forgot']);
    }

    public createAccount(): void {
        window.open(environment.signUpUrl);
    }

    public async verifyIfHasRedirectUrl(): Promise<void> {
        await this.activatedRoute.queryParams.subscribe(
            (params: Params) => {
                this.redirectUrl = params['redirectUrl'];
            }
        );
    }

    public disableLoginButton(): boolean {
        if (!this.showCode) {
            return (!this.email || !this.password);
        } else {
            return (!this.email || !this.password || this.code?.length !== 6);
        }
    }
}
